import React, { useEffect, useState } from "react";

export const EventsDivorce = () => {

	return (
		<div className="auto-view h-100 mb-auto pt-3">
			<div className="container-fluid h-xl-inherit">
				<button className="btn btn-white-secondary text-secondary shadow-xs mb-2">
					Déclarer un divorce
				</button>
			</div>
		</div>
	);
};
